import * as React from "react";
import { AutomationForm, AutomationFormScope } from "../Form/AutomationForm";
import { IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { IAutomation } from "../../../../config/automation";
import { updateAutomation } from "../../../../stores/automations";

interface IEditActionProps {
    value: any;
    onSave(value: any): void;
}

const EditButton = ({onClick}: any) => (
    <IconButton size="small" color="primary" onClick={onClick}>
        <Edit />
    </IconButton>
);

export const EditAction = ({value, onSave}: IEditActionProps) => {
    const handleUpdate = (value: any): Promise<IAutomation> => {
        return updateAutomation(value).then(res => {
            onSave(res);
            return res;
        });
    };

    return (
        <AutomationForm
            scope={AutomationFormScope.UPDATE}
            title="Update automation"
            value={value}
            onSave={handleUpdate}
            trigger={<EditButton />}
        />
    )
};
